export type EstadoType = 'PEN' | 'APR' | 'ANU';

export interface OrdenLiquidacionDetalle {
  id: number;
  idOrdenLiquidacion: number;
  idPresentacion: number;
  idCalibre: number;
  codigoPrecio: number;
  kilos: number;
  precioUnitario: number;
  monto: number;
  precioServicio: number;
  montoServicio: number;
  presentacion?: {
    idPresentacion: number;
    descripcion: string;
  };
  calibre?: {
    idCalibre: number;
    descripcion: string;
  };
}

export interface OrdenLiquidacion {
  id: number;
  numero: string;
  idDocumento: number;
  idProveedor: number;
  idGuiaProduccion: number;
  fechaProceso: string;
  tipoProceso: string;
  tipoOperacion: string;
  numeroMallas: number;
  totalKilos: number;
  subTotal: number;
  detraccion: number;
  totalServicio: number;
  totalLiquidar: number;
  duenio?: string;
  subLoteCantidad?: number;
  estado: EstadoType;
  observaciones?: string;
  fechaCreacion: string;
  idUsuarioCreacion?: number;
  documento?: {
    id: number;
    numeroDocumento?: string;
    asociacion?: {
      descripcion: string;
    };
  };
  proveedor?: {
    idPersona: number;
    razonSocial: string;
  };
  guiaProduccion?: {
    id: number;
    fechaMovimiento: string;
  };
  detalles: OrdenLiquidacionDetalle[];
}

export interface OrdenLiquidacionState {
  ordenes: OrdenLiquidacion[];
  loading: boolean;
  error: string | null;
}

export const estadoLabels: Record<EstadoType, string> = {
  'PEN': 'Pendiente',
  'APR': 'Aprobado',
  'ANU': 'Anulado',
};

export const estadoColors: Record<EstadoType, 'warning' | 'success' | 'error'> = {
  'PEN': 'warning',
  'APR': 'success',
  'ANU': 'error',
};
